import {
  base_colorAction,
  base_contentBackground,
  input_borderDefault,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { switch_transitionSpeed } from 'ext-ui/style/transitionSpeeds'
import { css } from 'styled-components'

/*
  Geometry is expressed on the 4px spacing scale so the switch scales with the
  rest of the system: a 40x24 track with a 20px thumb inset by 2px, which
  travels `TRACK_WIDTH - THUMB_SIZE - THUMB_INSET` when checked.
*/
const TRACK_WIDTH = spacing(10)
const TRACK_HEIGHT = spacing(6)
const TRACK_RADIUS = spacing(3)
const THUMB_SIZE = spacing(5)
const THUMB_INSET = spacing(0.5)
const THUMB_TRAVEL = spacing(10 - 5 - 0.5)

export default css`
  position: relative;
  flex: 0 0 auto;
  width: ${TRACK_WIDTH};
  height: ${TRACK_HEIGHT};
  padding: 0;
  border: none;
  border-radius: ${TRACK_RADIUS};
  background-color: ${input_borderDefault};
  cursor: pointer;
  transition: background-color ${switch_transitionSpeed} ease-out;

  &.checked {
    background-color: ${base_colorAction};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${base_colorAction};
    outline-offset: ${THUMB_INSET};
  }

  .Switch-thumb {
    position: absolute;
    top: ${THUMB_INSET};
    left: ${THUMB_INSET};
    width: ${THUMB_SIZE};
    height: ${THUMB_SIZE};
    border-radius: 50%;
    background-color: ${base_contentBackground};
    transition: left ${switch_transitionSpeed} ease-out;
  }

  &.checked .Switch-thumb {
    left: ${THUMB_TRAVEL};
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    .Switch-thumb {
      transition: none;
    }
  }
`
